var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.4,
    viewBox: "0 0 15 15.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_smartphone",
    "data-name": "icona smartphone",
    transform: "translate(-854 -107.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_smartphone-2",
    "data-name": "icona smartphone",
    transform: "translate(844 108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_431",
    "data-name": "Tracciato 431",
    d: "M20.4,0H14.1A1.1,1.1,0,0,0,13,1.1V13.9A1.1,1.1,0,0,0,14.1,15h6.3a1.1,1.1,0,0,0,1.1-1.1V1.1A1.1,1.1,0,0,0,20.4,0ZM13.5,2H21v9.5H13.5ZM14.1.5h6.3a.6.6,0,0,1,.6.6v.4H13.5V1.1A.6.6,0,0,1,14.1.5Zm6.3,14H14.1a.6.6,0,0,1-.6-.6V12H21v1.9A.6.6,0,0,1,20.4,14.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_432",
    "data-name": "Tracciato 432",
    d: "M27,49a1,1,0,1,0,1,1A1,1,0,0,0,27,49Zm0,1.5a.5.5,0,1,1,.5-.5A.5.5,0,0,1,27,50.5Z",
    transform: "translate(-9.75 -36.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_433",
    "data-name": "Tracciato 433",
    d: "M25.25,3.5h1a.25.25,0,0,0,0-.5h-1a.25.25,0,0,0,0,.5Z",
    transform: "translate(-9 -2.25)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_434",
    "data-name": "Tracciato 434",
    d: "M32.25,3.5h.25a.25.25,0,0,0,0-.5h-.25a.25.25,0,1,0,0,.5Z",
    transform: "translate(-14.25 -2.25)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_779",
    "data-name": "Rettangolo 779",
    transform: "translate(854 108)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.89cb3048292323772d1e29472665683b.svg";
export { ForwardRef as ReactComponent };